module.exports = __webpack_public_path__ + "b0b1845ecce8ab6a503971e808a8409c.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/RobotoCondensed-Regular.ttf
// module id = 508
// module chunks = 0